import useLocalePrice from './useLocalePrice'

interface Props {
  className?: string;
  price: number;
  currency: string;
}

const Price = ({ className = '', price, currency }: Props) => {
  return (
    <span className={className} suppressHydrationWarning>
      {useLocalePrice(price, currency)}
    </span>
  )
}

Price.defaultProps = {
  className: ''
}

export default Price
